import {Component, HostListener, OnInit} from '@angular/core';
import {AuthentificationService} from '../../login/services/authentification.service';
import {Router} from '@angular/router';

declare const $: any;

declare interface RouteInfo {
    path?: string;
    title?: string;
    icon?: string;
    class?: string;
    admin?: boolean

}

export const ROUTES: RouteInfo[] = [
    {path: '/dashboard', title: 'MENU.DASHBOARD', icon: 'dashboard', class: ''},
    {path: '/customers', title: 'MENU.CLIENTS', icon: 'person', class: '', admin: true},
    {path: '/partners', title: 'MENU.PARTNERS', icon: 'person', class: '', admin: true},
    {path: '/pub', title: 'MENU.PUBLICITY', icon: 'library_books', class: '', admin: true},
    {path: '/tags', title: 'MENU.TAGS', icon: 'library_books', class: '', admin: true},
    {path: '/categories', title: 'MENU.CATEGORY', icon: 'category', class: 'category', admin: true},
    {path: '/feed-back', title: 'MENU.FEED_BACK', icon: 'feedback', class: '', admin: true},
    {path: '/contact-us', title: 'MENU.CONTACT_US', icon: 'message', class: '', admin: true},
    {path: '/coupons', title: 'MENU.COUPON', icon: 'card_giftcard', class: '', admin: true},
    {path: '/profile', title: 'MENU.PROFILE', icon: 'person', class: '', admin: false}
    /*    {path: '/icons', title: 'Icons', icon: 'bubble_chart', class: '', admin: true},
        {path: '/notifications', title: 'Notifications', icon: 'notifications', class: '', admin: true},*/
];

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
    menuItems: any[];
    public bigScreen = true;

    @HostListener('window:resize', ['$event'])
    onResize(event?: any) {
        const screenHeight = window.innerHeight;
        const screenWidth = window.innerWidth;
        this.bigScreen = (screenHeight > 675) && (screenWidth > 991);

    }

    constructor(private authenService: AuthentificationService, private route: Router) {
        this.onResize();
    }

    ngOnInit() {
        if (this.authenService.isAdmin()) {
            this.menuItems = ROUTES.filter(menuItem => menuItem);
        } else {
            this.menuItems = ROUTES.filter(menuItem => !menuItem.admin);
            const index = this.menuItems.indexOf(item => item.title === 'MENU.PROFILE');
            this.menuItems.splice(index, 1);
            this.menuItems.push(
                {path: '/offers', title: 'MENU.OFFER', icon: 'store', class: '', admin: false},
                {path: '/profile', title: 'MENU.PROFILE', icon: 'person', class: '', admin: false}
            );
        }
    }

    isMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    };

    public onLogout() {
        localStorage.clear();
        sessionStorage.clear();
        this.route.navigateByUrl('/login');
    }
}
